import { ar } from './ar';
import { en, type MessageKey } from './en';

const catalogs = { en, ar } as const;

export type AppLocale = keyof typeof catalogs;

let locale: AppLocale = 'ar';

export function setLocale(next: AppLocale): void {
  locale = next;
}

export function getLocale(): AppLocale {
  return locale;
}

/** Translate UI copy. Source keys are English in en.ts; Arabic in ar.ts. */
export function t(key: MessageKey, fallback?: string): string {
  return catalogs[locale][key] ?? catalogs.en[key] ?? fallback ?? key;
}

export type { MessageKey };
